import PostsList from './posts-list';
import { queryArgsAsMap, getUrlWithQueryArgs, getUrlQueryArg } from '../../util/url-util';

class PostsListSearch extends PostsList {
	constructor(el) {
		super(el);

		this.setEndpoint('wp/v2/search');
		this.setCardContainerClasses('columns small-12 medium-6 large-4 equal-height-target');

		const cardsContainer = this.el.querySelector('.posts-list__cards-container');

		if (cardsContainer) {
			cardsContainer.classList.add('equal-height');
		}

		this.formSearchEl = this.el.querySelector('form#form_filter_search');

		this.filterSearch = getUrlQueryArg('s', '');

		if (this.loadMore) {
			this.loadMore.on('load', () => this.loadSearchResults(true));
		}

		if (this.formSearchEl) {
			this.formSearchEl.addEventListener('submit', (e) => {
				e.preventDefault();

				const inputEl = e.currentTarget.querySelector('input');

				if (inputEl) {
					this.filterSearch = inputEl.value.trim();

					this.updateURL();
					this.clearCardsContainer();
					this.loadSearchResults();
				}
			});
		}
	}

	loadSearchResults(focusNewResults = false) {
		const config = {
			search: this.filterSearch
		};

		this.loadMorePosts(config, focusNewResults);
	}

	updateURL() {
		const args = queryArgsAsMap();

		args.set('s', this.filterSearch);

		window.history.replaceState({}, '', getUrlWithQueryArgs(args));
	}
}

export default PostsListSearch;
